import React from 'react'
import '../About/Aboutus.css'
import Leading from './Leading'
import Why from '../Why/Why'
import Team from '../Team/Team'
import Connect from '../Connect/Connect'
import Text from './Text'
import Scroll from '../Scroll/Scroll'
const Aboutus = () => {
  return (
    <>
       <div className="poster-section-vv">
       <div className="overlay-p-vv">
  <h1 className='p-vvh'>About Us</h1>
  <p className='p-vvp'>At CA & Associates, we strive to be leaders in every financial and legal service we offer. With our in-depth understanding of both business and personal financial matters, we are committed to providing expert guidance and solutions tailored to your needs.</p>
</div>

  <div className="video-container-vv">
    <video 
      width="25rem" 
      height="100vh" 
      autoPlay 
      loop 
      muted 
      controls
    >
      <source src="/abouta2.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </div>
</div>

<Text/>
<Scroll/>
<Leading/>
<Why/>
<Team/>




    
    </>
  )
}

export default Aboutus